import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import InPlayer from '../backend/inplayer';
import Global from "../../global";
import Cookies from 'js-cookie';
import { PlanStore } from '../store/planStore';



const CommonRoute = ({ component: Component, ...rest }) => {

    // Add your own authentication on the below line.
    const plan = PlanStore.useState((s) => s.plan);
    const phone_verifed =  (Cookies.get('sm_ott_val')==="true");

    return (
      <Route
        {...rest}
        render={props =>
            !InPlayer.Account.isAuthenticated() ? (
            <Component {...props} />
          ) : (
            !phone_verifed && Global.OTP && (props.location.pathname!=="/"+props.match.params.AppId+"/verify" && props.location.pathname!=="/"+props.match.params.AppId+"/sendotp") ?
            <Redirect to={{ pathname: '/'+props.match.params.AppId+'/sendotp', state: { from: props.location } }} />:
            plan!==null?<Redirect to={{ pathname: '/'+props.match.params.AppId+'/home', state: { from: props.location } }} />:  <Redirect to={{ pathname: '/'+props.match.params.AppId+'/premium', state: { from: props.location } }} />
          )
        }
      />
    )
  }
  
  export default CommonRoute